import api from "./axiosInstance";

/**
 * @param {number} limit
 * @param {number} offset
 */
export const getDocuments = async (limit = 10, offset = 0) => {
  const response = await api.get(
    `api/v1/document-templates/?limit=${limit}&offset=${offset}`,
  );
  return response.data;
};

export const getDocumentById = async (documentId) => {
  const response = await api.get(`api/v1/document-templates/${documentId}`);
  return response.data;
};

export const createDocument = async (payload) => {
  const response = await api.post("api/v1/document-templates/", payload);
  return response.data;
};

export const updateDocument = async (documentId, payload) => {
  const response = await api.patch(
    `api/v1/document-templates/${documentId}/`,
    payload,
  );
  return response.data;
};

export const deleteDocument = async (documentId) => {
  await api.delete(`api/v1/document-templates/${documentId}/`);
};

export const sendDocumentForSign = async (documentId, payload) => {
  const response = await api.post(
    `api/v1/document-templates/${documentId}/send-for-signature/`,
    payload,
  );
  return response.data;
};

export const getDocumentForSign = async (documentId, token) => {
  const response = await api.get(
    `api/v1/documents/${documentId}/get/?stoken=${token}`,
  );
  return response.data;
};

export const submitSignedDocument = async (documentId, payload, token) => {
  const response = await api.post(
    `api/v1/documents/${documentId}/sign/?stoken=${token}`,
    payload,
  );
  return response.data;
};

export const getGeneratedDocuments = async () => {
  const response = await api.get(`api/v1/documents/`);
  return response.data;
};